import { routeName } from '@/constants/routeName';
import { parseQueryToken, hubSelectorDisabler, } from '@/router-middleware';
import WorkerAllocateWrapper from '@/views/Dialog/WorkerAllocate/PopupWrapper.vue';
export default {
    path: '/worker-allocate',
    name: routeName.WORKER_ALLOCATE,
    component: WorkerAllocateWrapper,
    meta: {
        middleware: [
            hubSelectorDisabler,
            parseQueryToken,
        ],
    },
};
